<template>
	<ul class="customers-modal-list" v-if="customers.length">
		<li
			class="customers-modal-list__item"
			v-for="customer in customers"
			:key="customer.key"
			:id="`${customer.value}_form`"
		>
			<!-- TODO: Review this button action -->
			<Button
				className="btn--inline-link customers-modal-list__item-link"
				:labelText="customer.text"
				:btnClick="redirectToCustomer"
			/>
		</li>
	</ul>
</template>

<script>
import Button from '@/components/forms/button/button';

export default {
	name: 'CustomersModalList',
	components: {
		Button
	},
	props: {
		customers: {
			type: Array
		}
	},
	methods: {
		redirectToCustomer() {
			console.log('go to clients');
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * 3P Vendor Manager - Vendor card - Customers Modal List
    * Can use SCSS variables = TRUE
*/

.customers-modal-list {
	overflow-y: auto;
	margin-top: $gutter-xl;
	max-height: calc(100vh - 260px);
	@include scrollbar;

	@include mq($from: md) {
		max-height: calc(87vh - 320px);
	}

	&__item {
		&:not(:first-child) {
			margin-top: $gutter-lg;
		}

		&-link {
			max-width: calc(100% - 12px);
			@include ellipsis;
		}
	}
}
</style>
